import {getWorkspaceFromUri} from './getWorkspaceFromUri';

const CARVAGO_WORKSPACE = 'carvago';

/**
 * The inspection equipment PDF is shown only in the Carvago workspace. DMS applies the same rule in
 * `libs/dms/features/inspection-equipment-document/src/utils/isCarvagoWorkspace.ts` (the app cannot
 * import `@dms/*`); keep the two in sync.
 */
export function isCarvagoWorkspace() {
  return getWorkspaceFromUri().workspace === CARVAGO_WORKSPACE;
}
